import React from 'react';
import styled from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';

const Container = styled.View`
  width: 100%;
  border-radius: 8px;
`;
const ItemContainer = styled.View`
  width: 100%;
  border-width: 1px;
  border-color: ${({theme}) => theme.primary};
  border-radius: 8px;
  margin-bottom: 5%;
`;

const FiltersModalSkeleton = () => {
  return (
    <Container>
      {[0, 1, 2, 3].map(item => (
        <ItemContainer key={item}>
          <SkeletonPlaceholder width={'100%'} height={40} borderRadius={8} />
        </ItemContainer>
      ))}
    </Container>
  );
};

export default FiltersModalSkeleton;
